export const conversion = {
    teaspoon: {
        teaspoon: 1,
        tablespoon: 0.3333,
        cup: 0.0208,
        ml: 5,
    },
    tablespoon: {
        teaspoon: 3,
        tablespoon: 1,
        cup: 0.0625,
        ml: 15,
    },
    cup: {
        teaspoon: 48,
        tablespoon: 16,
        cup: 1,
        ml: 240,
    },
    ml: {
        teaspoon: 0.2,
        tablespoon: 0.0667,
        cup: 0.0042,
        ml: 1,
    },
};
